module.exports = __webpack_public_path__ + "img/BannerMathMastery.d9a0de4f.png";